module.exports = __webpack_public_path__ + "img/logo.c4020160.svg";